"use strict";

exports.__esModule = true;
exports.default = void 0;
var isAbsent = function isAbsent(value) {
  return value == null;
};
var _default = exports.default = isAbsent;